export default __webpack_public_path__ + "static/media/Maharaja07.1270e550.jpg";